module.exports = __webpack_public_path__ + "img/notification.6e51ff98.svg";